import { createSlice } from '@reduxjs/toolkit';

export const aiAnalysisSlice = createSlice({
  name: 'aiAnalysis',
  initialState: {
    data: {},
  },
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setData } = aiAnalysisSlice.actions;
export default aiAnalysisSlice.reducer;
